<template>
  <div full-height>
    <Loading v-if="loading" :text="text"/>
    <!-- Maintenance Message -->
    <div v-if="maintenanceInfo.is_active" class="maintenance-container">
      <div class="maintenance-message">
        <h2>メンテナンス中</h2>
        <p>{{ maintenanceInfo.message }}</p>
      </div>
    </div>

    <template v-else>
      <Header :htitle="htitle"/>
      <!-- Category Filter -->
      <div class="category-container">
          <!-- Category Level 1 -->
          <div class="scrollable-major-buttons">
              <el-button
                  v-for="(category, index) in categoryMajor"
                  :key="index"
                  :class="['category-button', { active: selectedMajorCategoryId === category.categoryId }]"
                  @click="selectMajorCategory(category)"
              >
                  {{ category.name }}
              </el-button>
          </div>
          <!-- Category Level 2 -->
          <div class="scrollable-buttons" v-if="this.selectedMajorCategoryId">
              <el-button
                  v-for="(category, index) in categoryMedium"
                  :key="index + '_medium'"
                  class="category-btn"
                  :class="{ active: selectedMediumCategoryId == category.categoryId }"
                  @click="selectMediumCategory(category)">
                  {{ category.name }}
              </el-button>
          </div>
          <!-- Category Level 3 -->
          <div class="scrollable-buttons" v-if="selectedMediumCategoryId">
              <el-button
                  v-for="(category, index) in categorySmall"
                  :key="index + '_small'"
                  class="category-btn"
                  :class="{ active: selectedSmallCategoryId == category.categoryId }"
                  @click="selectSmallCategory(category)">
                  {{ category.name }}
              </el-button>
          </div>
           <!-- Category Level 3 -->
           <div class="scrollable-buttons" v-if="selectedSmallCategoryId">
              <el-button
                  v-for="(category, index) in categoryTiny"
                  :key="index + '_small'"
                  class="category-btn"
                  :class="{ active: selectedTinyCategoryId == category.categoryId }"
                  @click="selectTinyCategory(category)">
                  {{ category.name }}
              </el-button>
          </div>
      </div>
      <main>

        <div class="product__scroll">
          <Product v-for="(product , index) in product_list" :product="product" :key="index" v-if="product && product.view" @show-modal="openModal"/>
        </div>
        <div style="margin-bottom: 12px;" v-if="!isScanView && canShowMore">
          <el-button
              style="width: 100%; text-align: center;border-radius: 8px;border: 1px solid var(--grayColor);" 
              @click="loadMore()">もっと見る</el-button>
        </div>
        <div style="margin-bottom: 12px;" v-if="isScanView">
            <el-button
                style="width: 100%; text-align: center;border-radius: 8px;border: 1px solid var(--grayColor);" 
                @click="reloadHomeFirstPage()">商品一覧を再読み込み</el-button>
        </div>
        <el-button 
          class="btn-scroll-top"
          icon="el-icon-top"
          @click="scrollTop"></el-button>
      </main>

    <div v-if="modalData" class="modal">
        <div class="modal__box">
            <img src="/resource/icon_cross_in_circle.svg" class="modal__box__back" @click="closeModal"/>
            <img :src="modalData.image" class="modal__box__image" />
            <p class="modal__box__product-name">{{ modalData.product_name }}</p>
            <p class="modal__box__product-price">{{ modalData.price ? `${numberFormat(modalData.price)}円${modalData.unit_code ? ` / ${modalData.unit_code}` : ''}` : '' }}</p>
        </div>
    </div>

    <Footer/>
    </template>
  </div>
</template>

<script>
import { mapState , mapGetters, mapActions } from 'vuex'

export default {

    // https://liff.line.me/1656948912-Y5M1R9m7

    head: {
        title: '発注画面',
    },

    data: () => {
        return {
            loading: true,
            text : '設定を読み込んでいます...',

            product_list : [],
            search_word  : '',

            htitle : '商品一覧',
            currentPage: 1,
            perPage: process.env.B2B_PER_PAGE,
            canShowMore: true,
            isScanView: false,
            categoryMajor: [],
            categoryMedium: [],
            categorySmall: [],
            categoryTiny: [],

            categoryMajorOrigin: [],
            categoryMediumOrigin: [],
            categorySmallOrigin: [],
            categoryTinyOrigin: [],

            selectedCategoryId: null,
            selectedMajorCategoryId: null,
            selectedMediumCategoryId: null,
            selectedSmallCategoryId: null,
            selectedTinyCategoryId: null,
            modalData: null,
        }
    },

    watch : {

        search_word: async function( newer , older ) {

            var clone = await JSON.parse( JSON.stringify( this.products ) )

            this.product_list = await Promise.all( clone.map( async ( p )=>{

                p.view = await ( p.extract.includes( newer ) )? true : false

                return await p

            }))

        },
    
        products: {
            deep: true,
            handler: async function(newProducts) {
                // Merge quantities from cart to avoid resetting to 0
                const merged = (newProducts || []).map(p => {
                    const cp = JSON.parse(JSON.stringify(p))
                    const inCart = Array.isArray(this.cart) ? this.cart.find(c => c.product_id == cp.product_id) : null
                    cp.quantity = inCart ? inCart.quantity : (cp.quantity || 0)
                    // ensure flags exist
                    cp.view = cp.view !== undefined ? cp.view : true
                    cp.popup = cp.popup !== undefined ? cp.popup : false
                    cp.lock = cp.lock !== undefined ? cp.lock : false
                    if (cp.from_scan) this.isScanView = true
                    return cp
                })
                this.product_list = merged
            }
        },
    
    },

    async mounted(){

        await console.clear()

        await this.$store.dispatch('maintenance/checkMaintenance')
        // liff initialyze
        if( liff != void 0 && liff ){

            // LIFF アプリの初期化
            await liff.init({ liffId : process.env.LIFF_ID }).then( async() => {

                this.appInit()

            }).catch((err) => { console.log(err.code, err.message); })

        }

    },
    computed: {


        ...mapGetters( 'config'  ,[ 'config' , 'products' , 'userProfile' , 'units' , 'favorites' , 'delivConfig' ] ),
        ...mapGetters( 'cart'    ,[ 'cart' , 'cartCount' , 'session_id' ] ),
        ...mapGetters('maintenance', ['maintenanceInfo', 'isMaintenanceMode']),
    },
    methods:{
        ...mapActions('config'  ,[ 'setConfig' , 'setProducts' , 'setUserProfile' , 'setUnits' , 'setFavorites' , 'setDelivConfig' ]),
        ...mapActions('cart'    ,[ 'setCart' , 'clearCart' , 'setSession' ]),

        /************************************************
         *  User Initialyze
        ************************************************/
        appInit : async function(){

            if( liff != void 0 && liff ){

                await liff.ready.then( async () => {

                    if ( !liff.isLoggedIn() ){ 

                        await liff.login()

                    }

                    else{

                        if( this.userProfile.user_id == void 0 ){

                            this.text = await 'ユーザー情報をチェックしています'

                            // get id token
                            var token = await this.getIDToken()

                            // check user data in DataBase. ( if not in database, insert new user data )
                            var userCheck = await this.checkUser( token )

                            if( userCheck.status == 'success' ){

                                await this.setUserProfile( userCheck.user )

                                // カート情報
                                if( this.cart == '' ){

                                    var cart_data = await this.loadCart()
                                    await this.setCart( cart_data.cart )
                                    await this.appSetup()

                                }
                                else{

                                    await this.appSetup()

                                }

                            }
                            else{
                                this.loading = false
                                await liff.logout()
                                await this.$alert( userCheck.message, userCheck.status, {
                                    showConfirmButton: false,
                                    showClose: false,
                                    type : userCheck.status,
                                    dangerouslyUseHTMLString : true,
                                    callback: action => {
                                        liff.closeWindow();
                                    }
                                });
                            }
                        }

                        else{

                            // カート情報
                            if( this.cart == '' ){

                                var cart_data = await this.loadCart()
                                await this.setCart( cart_data.cart )
                                await this.appSetup()

                            }
                            else{

                                await this.appSetup()

                            }

                        }

                    }

                })

            }

        },

        resetCurrentPage() {
            this.currentPage = 1
        },

        async selectMajorCategory(category) {
            const categoryMajorId = category.categoryId

            if(this.selectedMajorCategoryId == categoryMajorId) {
                // this.selectedMajorCategoryId = null

                // this.categoryMedium = []
                this.categoryMedium = this.categoryMediumOrigin.filter(category => {
                    return category.parentId === categoryMajorId;
                });
                this.categorySmall = []
            }else {
                this.selectedMajorCategoryId = categoryMajorId
                this.categoryMedium = this.categoryMediumOrigin.filter( category => {
                    return category.parentId === categoryMajorId
                })
            }
            this.selectedMediumCategoryId = null
            this.selectedSmallCategoryId = null
            this.selectedTinyCategoryId  = null
            this.resetCurrentPage()
            await this.loadShopProducts()
        },

        async selectMediumCategory(category) {
            const categoryMediumId = category.categoryId

            if(this.selectedMediumCategoryId == categoryMediumId) {
                // this.selectedMediumCategoryId = null

                // this.categorySmall = []
                this.categorySmall = this.categorySmallOrigin.filter(category => {
                    return category.parentId === categoryMediumId;
                });
                this.categoryTiny = []
            }else {
                this.selectedMediumCategoryId = category.categoryId
                this.categorySmall = this.categorySmallOrigin.filter( category => {
                    return category.parentId === categoryMediumId
                })
            }
            this.selectedSmallCategoryId = null
            this.selectedTinyCategoryId  = null

            this.resetCurrentPage()
            await this.loadShopProducts()
        },

        async selectSmallCategory(category) {
            const categorySmallId = category.categoryId

            if(this.selectedSmallCategoryId == categorySmallId) {
                // this.selectedSmallCategoryId = null
                this.selectedTinyCategoryId = null

                // this.categoryTiny = []
                this.categoryTiny = this.categoryTinyOrigin.filter(category => {
                    return category.parentId === categorySmallId;
                });
            }else {
                this.selectedSmallCategoryId = categorySmallId
                this.categoryTiny = this.categoryTinyOrigin.filter( category => {
                    return category.parentId === categorySmallId
                })
            }
            this.selectedTinyCategoryId = null
            this.resetCurrentPage()
            await this.loadShopProducts()
        },

        async selectTinyCategory(category) {
            if(this.selectedTinyCategoryId == category.categoryId) {
                // this.selectedTinyCategoryId = null
            }else {
                this.selectedTinyCategoryId = category.categoryId
            }
            this.resetCurrentPage()
            await this.loadShopProducts()
        },

        getCategoryId() {
            return this.selectedTinyCategoryId || this.selectedSmallCategoryId || this.selectedMediumCategoryId || this.selectedMajorCategoryId
        },

        /* get line login token.
        ************************************************/
        getIDToken : async function() {

            return await new Promise( function( resolve ) {

                resolve( liff.getIDToken() );

            });  

        },

        /* check user in DataBase.
        ************************************************/
        checkUser : async function( token ){

            return await this.$axios.get(`${process.env.MAIN_API}/checkUser/${token}`).then( function(result){

                return result.data

            }.bind(this)).catch((err) => { console.dir(err); })

        },

        /************************************************
         * Application Set UP.
        ************************************************/
        appSetup : async function(){

            if( !this.units ){

                var product_units = await this.loadUnits()
                await this.setUnits( product_units?.units || '' )

            }

            if( !this.favorites ){

                var fav_data = await this.loadFavorites()
                await this.setFavorites( fav_data?.data || '' )

            }

            if( !this.delivConfig ){

                var delivData = await this.loadDeliv()
                await this.setDelivConfig( delivData?.data || '')

            }


            this.text = '商品リストを読み込み中...'
            await this.loadCategories()
            await this.loadShopProducts()
        },

        // get categories
        loadCategories : async function(){
            return await this.$axios.get(`${process.env.MAIN_API}/aec/categories-by-level`).then( function(response){
                response.data.data.level1.unshift({
                    categoryId: null,
                    level: 1,
                    name: '全て'
                })
                this.categoryMajorOrigin = response.data.data.level1;
                this.categoryMediumOrigin = response.data.data.level2
                this.categorySmallOrigin = response.data.data.level3
                this.categoryTinyOrigin = response.data.data.level4

                this.categoryMajor = [...this.categoryMajorOrigin]
                this.categoryMedium = [...this.categoryMediumOrigin]
                this.categorySmall = [...this.categorySmallOrigin]
                this.categoryTiny = [...this.categoryTinyOrigin]

            }.bind(this)).catch((err) => { console.dir(err); })

        },

        async loadMore() {
            this.currentPage = this.currentPage + 1
            await this.loadShopProducts()
        },

        // Get product list with shop_code.
        loadShopProducts : async function(){
            const categoryId = this.getCategoryId()
            const params = `?currentPage=${this.currentPage}&perPage=${this.perPage}&categoryId=${categoryId}`

            await this.$axios.get(`${process.env.MAIN_API}/b2b/products/${this.userProfile.shop_code}${params}`)
            .then(function(result) {
                const {totalProduct, currentPage, perPage, products, status, message} = result.data
                const productsData = currentPage == 1 ? products : [...this.products,...products]
                const countProduct = currentPage * perPage
                if( status == 'success' && !message ) {
                    this.setProducts(productsData)
                    this.perPage = perPage
                    this.canShowMore = (countProduct >= totalProduct)? false : true
                    this.currentPage = currentPage
                    this.product_list = JSON.parse( JSON.stringify(productsData) )                    
                    this.loading = false
                } else {
                    this.alertBox( status, message, status )
                    this.loading = false
                    liff.logout()
                }
            }.bind(this))
            .catch((err) => { console.dir(err); })
        },

        reloadHomeFirstPage: async function(){
            this.isScanView = false
            this.currentPage = 0
            this.canShowMore = true
            await this.setProducts([])
            await this.loadShopProducts()
        },

        // Get unit list with shop_code.
        loadUnits : async function(){

            return await this.$axios.get(`${process.env.MAIN_API}/units`).then( function(result){

                return result.data

            }.bind(this)).catch((err) => { console.dir(err); })

        },


        // Get user cart in data base.
        loadCart : async function(){

            return await this.$axios.get(`${process.env.MAIN_API}/cart`).then( function(result){

                return result.data

            }.bind(this)).catch((err) => { console.dir(err); })

        },

        // Get user Favorites Data.
        loadFavorites : async function(){

            return await this.$axios.get(`${process.env.MAIN_API}/favorites`).then( function(result){

                return result.data

            }.bind(this)).catch((err) => { console.dir(err); })

        },

        // Get delivery Config Data.
        loadDeliv : async function(){

            return await this.$axios.get(`${process.env.MAIN_API}/deliveryConfig`).then( function(result){

                return result.data

            }.bind(this)).catch((err) => { console.dir(err); })

        },





        /***************************************************************
         * type (str) : success / info / warning / error
         * https://element.eleme.io/#/en-US/component/message-box
        ****************************************************************/
        alertBox : async function( title , message , type ){

            this.$alert( message , title , {
              confirmButtonText: 'OK',
              type : type,
              dangerouslyUseHTMLString : true,
              callback: action => {

                return

              }
            });

        },
        scrollTop () {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        openModal(product) {
            this.modalData = {
                image: product.product_image_origin,
                product_name: product.product_name,
                price: product.now_price > 0 
                    ? product.now_price 
                    : product.base_price,
                unit_code: product.unit_code,
            };
        },
        closeModal() {
            this.modalData = null;
        },

        numberFormat(value) {
            let formatter = new Intl.NumberFormat('ja-JP');
            return formatter.format(value);
        },

    },
    filters:{

        number_format : function (value) {
            let formatter = new Intl.NumberFormat('ja-JP');
            return formatter.format(value);
        },

    },

}
</script>

<style scoped>

    .btn-scroll-top {
        position: fixed;
        bottom: 92px;
        right: 12px;
        z-index: 100;
        border-radius: 8px;
        border: 1px solid var(--grayColor);
        box-shadow: 5px 5px 5px 0;
        padding: 12px !important;
    }

    .category-container {
        margin-top: 50px;
        background-color: #fff;
    }

    .scrollable-buttons {
        display: flex;
        overflow-x: auto;
        border-bottom: 1px solid #cccccc;
        white-space: nowrap;
        padding: 10px 10px;
        scrollbar-width: none;
    }

    .scrollable-major-buttons {
        display: flex;
        overflow-x: auto;
        border-bottom: 1px solid #cccccc;
        white-space: nowrap;
        padding-bottom: 8px;
        scrollbar-width: none;
    }

    .scrollable-major-buttons .category-button.active::before {
        content: '';
        position: absolute;
        bottom: -12px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #f0a10c
    }

    .category-button {
        background-color: transparent;
        color: black;
        border-radius: 0;
        padding: 8px 16px;
        margin: 4px;
        border: none;
        cursor: pointer;
        font-weight: bold;
        position: relative;
    }

    .category-button.active {
        color: #f0a10c;
    }

    .category-btn {
        margin-right: 10px;
        padding: 8px 16px;
        white-space: nowrap;
        color: black;
        background-color: #fff;
        border-radius: 20px;
        font-size: 12px;
        transition: background-color 0.3s ease, color 0.3s ease;
        cursor: pointer;
    }
      
    .category-btn.active {
        color: #fff;
        background-color: gray;
        font-weight: bold;
        opacity: 0.8;
    }
    
    .category-btn:hover {
        color: #fff;
        background-color: gray;
        font-weight: bold;
        opacity: 0.8;
    }
</style>